import { createContext } from 'react';

export const TextMessagesContext = createContext(null);
